/**
 * `/$org/apps/probe/practice`: Probe's Home. `?area=<area>` (from a review's
 * areas) opens it on one examination area; `?show=interviews` (the sidebar's
 * All interviews) opens every interview.
 *
 * @module routes/$org.apps.probe.practice
 */
import { createFileRoute } from "@tanstack/react-router";

import { areaFromSlug } from "../components/apps/probe/probeArea";
import type { HomeShow } from "../components/apps/probe/home/probeHome";
import { homeShowOf, ProbeHomePage } from "../components/apps/probe/ProbeHomePage";

export interface ProbeHomeSearch {
  readonly area?: string;
  readonly show?: HomeShow;
}

export const Route = createFileRoute("/$org/apps/probe/practice")({
  validateSearch: (search: Record<string, unknown>): ProbeHomeSearch => {
    const show = homeShowOf(search.show);
    return {
      ...(typeof search.area === "string" && areaFromSlug(search.area) !== null ? { area: search.area } : {}),
      ...(show === null ? {} : { show }),
    };
  },
  component: ProbeHomePage,
});
